import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Shell } from "./components/Shell";
import { StaleBuildBanner } from "./components/StaleBuildBanner";
import { OutageBanner } from "./components/OutageBanner";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("root element missing from index.html");

// Shell owns all routing and gating: it serves the public pages (/apply,
// /terms, /privacy), shows the desktop-required notice on mobile/narrow
// windows, and otherwise gates the wizard behind the Landing access-code
// screen. See Shell.tsx. StaleBuildBanner sits beside it (not inside) so a
// tab running an older bundle than the current deployment shows a reload bar
// on every surface this bundle serves.
createRoot(root).render(
  <StrictMode>
    <StaleBuildBanner />
    <OutageBanner />
    <Shell />
  </StrictMode>,
);
